window.onload = function() {

  
setInterval(function(){
  $('.rsearch input').attr('placeholder','Search for products...');
  $('.select__select option').each(function(){
    check_unavailable = $(this).text();
    if(check_unavailable.indexOf('Unavailable') > 1){
      jQuery(this).addClass('hidden');
    }else{
      jQuery(this).removeClass('hidden');
    }
  })
  $('.selectboxit-options li').each(function(){
    check_unavailable = $(this).find('a').text();
    if(check_unavailable.indexOf('Unavailable') > 1){
      jQuery(this).addClass('hidden');
    }else{
      jQuery(this).removeClass('hidden');
    }
  })
  if(jQuery('.boost-sd__filter-tree-vertical-option-list').children().length < 1){
    jQuery('.boost-sd-left').addClass('disabled');
  }else{
    jQuery('.boost-sd-left').removeClass('disabled');
  }
},300);

  jQuery(".select__select").selectBoxIt({
  "native": true,
    
  });

                                  
}